import React, { FC } from 'react';
import { Box, Flex, Text } from 'roo-ui/components';
import { monthNames, weekdayNames } from './constants';
import { CalendarCell } from './CalendarCell';
import styled from '@emotion/styled';
import { DateRangeRenderProps } from '../types';
import { CalendarNav } from './CalendarNav';
import { InlineLayout } from './InlineLayout';
import { MobileLayout } from './MobileLayout';

export const DateRangePicker: FC<DateRangeRenderProps> = (props) => {
  const content = (
    <Flex position="relative" px={[4, 10]} py={[6, 10]} minWidth={[0, '530px', '750px']}>
      <CalendarNav {...props} />
      {props.calendars.map((calendar) => (
        <Box
          data-testid="date-range-picker-month"
          key={calendar.month}
          {...props.getMonthProps()}
          width={`calc(100%/${props.monthsToDisplay})`}
          px={4}
        >
          {/* months display */}
          <Uppercase
            data-testid="date-range-picker-month-title"
            display="block"
            textAlign="center"
            fontSize="lg"
            fontWeight="bold"
            color="greys.charcoal"
          >
            {monthNames[calendar.month]} {calendar.year}
          </Uppercase>

          {/* weeks display */}
          <Flex pb="2" mt="5" mb="3" borderColor="greys.alto" borderBottom="1">
            {weekdayNames.map((name) => (
              <Box data-testid="date-range-picker-weekday-title" textAlign="center" key={name} width="calc(100%/7)">
                {name}
              </Box>
            ))}
          </Flex>

          {/* days display */}
          <Flex data-testid="date-range-picker-cells" flexWrap="wrap">
            {calendar.weeks.map((week, weekIndex) =>
              week.map((dateObj, dayIndex) => <CalendarCell key={`${weekIndex}_${dayIndex}`} dateObj={dateObj} {...props} />),
            )}
          </Flex>
        </Box>
      ))}
    </Flex>
  );

  if (props.isSmall) {
    return <InlineLayout {...props}>{content}</InlineLayout>;
  }

  return <MobileLayout {...props}>{content}</MobileLayout>;
};

const Uppercase = styled(Text)`
  text-transform: uppercase;
`;
